import RadioButton from './material/radio/RadioButton'
import InputField from './material/input/InputField'
import DateTimeField from './material/dateTime/DateTimeField'

const index = {
  radio: RadioButton,
  input: InputField,
  dateTime: DateTimeField
}

export default index
export type FieldName = keyof typeof index
